module.exports = __webpack_public_path__ + "static/media/06Demo Photo-ink.c67af61d.jpeg";